import {getCdnUrl, getEnvironment} from "../sharedFunctions";

export const resolveImagePath = (path, isWP) => {
  const image = new Image();
  image.src = window.location.origin + '/' + path;
  let cdnUrl = getCdnUrl();
  let fallbackPath = cdnUrl + path;

  // if(!isWP){
  //   console.log("Path: ", image.src);
  // } else {
  //   console.log("Fallback Path: ", fallbackPath);
  // }
  return !isWP ? image.src : fallbackPath;
};
